export const COMPANY = {
    name: "PISI LIMITED",
    tagline: "Wholesale & Retail",
    phone: "07438989869",
    phoneHref: "tel:+447438989869",
    email: "pisilimitedhello@gmail.com",
    emailHref: "mailto:pisilimitedhello@gmail.com",
    addressLines: ["5 Cotelands", "Croydon", "CR0 5UD", "United Kingdom"],
    addressInline: "5 Cotelands, Croydon, CR0 5UD, United Kingdom",
};

export const NAV_LINKS = [
    { label: "Home", hash: "#home", testId: "nav-link-home" },
    { label: "About Us", hash: "#about", testId: "nav-link-about" },
    { label: "Products", hash: "#products", testId: "nav-link-products" },
    { label: "Wholesale", hash: "#wholesale", testId: "nav-link-wholesale" },
    { label: "Contact", hash: "#contact", testId: "nav-link-contact" },
];

export const ENQUIRY_TYPES = [
    "General Enquiry",
    "Wholesale Enquiry",
    "Product Enquiry",
    "Business Partnership",
    "Other",
];

export const CATEGORIES = [
    {
        title: "Groceries",
        description: "Everyday grocery and food products.",
        image: "/images/groceries.jpg",
        alt: "Fresh grocery produce displayed on retail shelving",
        testId: "product-card-groceries",
    },
    {
        title: "Beverages",
        description: "A selection of everyday beverages and drinks.",
        image: "/images/beverages.jpg",
        alt: "A glass of fresh orange juice representing everyday beverages",
        testId: "product-card-beverages",
    },
    {
        title: "Household Products",
        description: "Practical household and domestic products.",
        image: "/images/household.jpg",
        alt: "Household cleaning and domestic products on a counter",
        testId: "product-card-household",
    },
    {
        title: "Consumer Goods",
        description: "Everyday consumer products across a range of categories.",
        image: "/images/consumer-goods.jpg",
        alt: "Supermarket aisle stocked with everyday consumer goods",
        testId: "product-card-consumer-goods",
    },
    {
        title: "General Retail Products",
        description: "A broader selection of products for everyday customer needs.",
        image: "/images/general-retail.jpg",
        alt: "General retail merchandise displayed in a store",
        testId: "product-card-general-retail",
    },
    {
        title: "Wholesale Supply",
        description: "Product supply options for businesses and commercial customers.",
        image: "/images/wholesale-supply.jpg",
        alt: "Stockroom shelves stocked with boxed products ready for supply",
        testId: "product-card-bulk-wholesale",
    },
];
